<template>
    <section>
        <loading id="spinner" :active="loading" :can-cancel="false" :is-full-page="true"></loading>
		
        <!-- DADOS BASICOS -->
        <div class="row">
            <div class="col s12">
                <!-- DADOS BASICOS -->
                <div class="card-panel">


                    <div class="row">
                        <h5 class="col s12">
                            Dados básicos
                        </h5>

                        <div class="input-field col s6">
                            <input type="text" readonly id="usuario_cpf"
                                   name="usuario_cpf"
                                   :value="usuarioLogado.cpf">
                            <label for="usuario_cpf">CPF</label>
                        </div>

                        <div class="input-field col s6">
                            <input type="text" readonly id="usuario_name"
                                   name="usuario_name"
                                   :value="usuarioLogado.name">
                            <label for="usuario_name">Nome</label>
                        </div>

                        <div class="input-field col s12">
                            <input type="text" readonly id="usuario_email"
                                   name="usuario_email"
                                   :value="usuarioLogado.email">
                            <label for="usuario_email">E-mail</label>
                        </div>

                    </div>


                </div>
            </div>
        </div>

        <!-- FORMULÁRIO DE INSCRIÇÃO -->
        <div class="row">
            <div class="col s12">
                <form id="formInscricao" :action="routeSaveData" method="post" class="card-panel">

                    <input name="_token" type="hidden" :value="csrfToken">

                    <div class="row">
                        <h5 class="col s12">Formulário de Inscrição</h5>
                    </div>

                    <!-- DADOS DA AÇÃO -->
                    <div class="row">
                        <div class="col s12">

                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Dados da ação</h5>

                                    <div class="input-field col s12">
                                        <select v-if="modoTela === 'cadastro'" name="sel_escolha_acao" id="sel_escolha_acao"
                                                v-model="inscricao.acaos_id"
                                                class="materialize-select">
                                            <option value="" disabled>Selecione uma ação</option>
                                            <option v-for="(acao, acao_i) in acoesParaInscricao"
                                                    :value="acao.id"
                                                    :title="acao.titulo"
                                                    :key="acao_i">{{ acao.titulo }}</option>
                                        </select>



                                        <input v-else type="text"
                                               name="sel_escolha_acao" id="sel_escolha_acao"
                                               disabled
                                               tipo="materialize"
                                               :value="inscricao.acao.titulo">

                                        <label for="sel_escolha_acao">Ação</label>
                                    </div>

                                    <div class="input-field col s6">
                                        <input type="text"
                                               name="siga_acao_id" id="siga_acao_id"
                                               :value="!acaoSelecionada ? 'Selecione a ação' : (acaoSelecionada.siga_acao_oid ? acaoSelecionada.siga_acao_oid : 'Essa Ação não veio do Siga e por isso não possui ID')"
                                               disabled />

                                        <label for="siga_acao_id">ID (API SIGA)</label>
                                    </div>

                                    <div class="input-field col s6">
                                        <input type="text"
                                               name="acao_centro" id="acao_centro"
                                               :value="!acaoSelecionada ? 'Selecione a ação' : acaoSelecionada.centro"
                                               disabled />

                                        <label for="acao_centro">Centro</label>
                                    </div>

                                    <div class="input-field col s6">
                                        <input type="text"
                                               name="acao_unidade" id="acao_unidade"
                                               :value="!acaoSelecionada ? 'Selecione a ação' : acaoSelecionada.unidade"
                                               readonly />

                                        <label for="acao_unidade">Unidade</label>
                                    </div>

                                    <div class="input-field col s6">
                                        <input type="text"
                                               name="acao_modalidade" id="acao_modalidade"
                                               :value="!acaoSelecionada ? 'Selecione a ação' : acaoSelecionada.modalidade"
                                               readonly/>
                                        <label for="acao_modalidade">Modalidade</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <b style="color:gray"
                       v-if="modoTela === 'visualizaAvaliacoes' && avaliacoes != null && avaliacoes.length > 0">
                        * Avaliações inválidas
                    </b>
                    <!-- QUESTIONARIO -->
                    <div class="row" v-if="modoTela !== 'correcao' || retornaSeItemEncontraSeEmPendenciaNaAnaliseTecnica('item_relatorio_acao_siga')">
                        <div class="col s12">
                            <div class="card-panel" :style="retornaBordaVermelhaNoItemEmPendenciaNaAnaliseTecnica('item_relatorio_acao_siga')">
                                <div class="row">
									<div class="col s12 red darken-1 white-text" v-if="retornaSeItemEncontraSeEmPendenciaNaAnaliseTecnica('item_relatorio_acao_siga')">
                                        <p>
                                            <i class="material-icons left">info_outline</i>
                                            <span style="font-weight: bold;">Aviso!</span>
                                            <span> Este item encontra-se pendênciado na análise técnica, por favor realize a correção. </span>
                                        </p>
                                    </div>
                                    <h5 class="col s12">Questionário</h5>
                                    <p v-if="!acaoSelecionada" class="label-info-nao-encontrada">Nenhuma ação foi
                                                                                                 selecionada ainda!</p>
                                    <Inscricao_questionario_itens v-else
                                                                  :all-disabled="retornaSeFormularioDesabilitadoParaEdicao"
                                                                  :p-itens.sync="inscricao.itens"
                                                                  :p-avaliacoes="avaliacoes"
																  :modalidade="acaoSelecionada.modalidade"
																  :correcao="modoTela === 'correcao' && retornaSeItemEncontraSeEmPendenciaNaAnaliseTecnica('item_relatorio_acao_siga')"></Inscricao_questionario_itens>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- CRONOGRAMA DE ATIVIDADES -->
                    <div class="row" v-if="modoTela !== 'correcao'">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Cronograma de Atividades</h5>

                                    <p v-if="!acaoSelecionada" class="label-info-nao-encontrada">Nenhuma ação foi selecionada ainda!</p>

                                    <Cronograma_atividades v-else
                                                           :all-disabled="retornaSeFormularioDesabilitadoParaEdicao"
                                                           :tem-acao-selecionada="acaoSelecionada != null"
                                                           :modalidade="acaoSelecionada ? acaoSelecionada.modalidade : 'N/a'"
                                                           :quantidade-maxima-de-meses="configuracaoDaModalidadeDaAcaoSelecionada ? configuracaoDaModalidadeDaAcaoSelecionada.numero_meses : 1"
                                                           :p-cronograma-de-atividades.sync="inscricao.cronograma_de_atividades"
														   :msg-cronograma-atividades="msgCronogramaAtividades"
                                                           :p-avaliacoes="avaliacoes"></Cronograma_atividades>
                                </div>
                            </div>
                        </div>
                    </div>
					
					<!-- QUANTITATIVO DE PÚBLICO DO EVENTO -->
                    <div v-if="acaoSelecionada && acaoSelecionada.modalidade == 'Evento' && modoTela !== 'correcao'" class="row">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Quantitativo de público externo atendido</h5>   
                                </div>
								<div class="row">
									<div class="input-field col s12">
										<select name="evento_qtdo"
												id="evento_qtdo"
												tipo="materialize"
												:disabled="retornaSeFormularioDesabilitadoParaEdicao"
												v-model.number="inscricao.evento_qtdo"
												class="validate browser-default">
											<option value=null disabled selected>Número de pessoas</option>
											<option v-for="(qtdo, index) in eventoQtdos" :value=index>{{qtdo[0]}}</option>
										</select>
									</div>
                                </div>
								<Resultado_avaliacoes_qtdo_evento
												 v-if="avaliacoes"
												 :avaliacoes="avaliacoes"
												 :inscricao="inscricao"
												 :eventoQtdos="eventoQtdos"></Resultado_avaliacoes_qtdo_evento>
                            </div>
                        </div>
                    </div>
					
					<!-- QUANTITATIVO DE TURMAS DO CURSO -->
                    <div v-if="acaoSelecionada && acaoSelecionada.modalidade == 'Curso' && inscricao.turma && modoTela !== 'correcao'" class="row">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Quantidade de turmas ofertadas durante o edital</h5>   
                                </div>
								<div class="row">
									<div class="input-field col s7">
										<p><b>Quantas turmas serão ofertadas durante a vigência do edital?</b></p>
									</div>
									<div class="input-field col s5">
										<select name="qtde_turmas"
												id="qtde_turmas"
												tipo="materialize"
												:disabled="retornaSeFormularioDesabilitadoParaEdicao"
												v-model.number="inscricao.turma.qtde_turmas"
												class="validate browser-default">
											<option value=0 disabled selected>Quantidade de turmas</option>
											<option v-for="(qtdo, index) in 6" :value=qtdo>{{qtdo}}</option>
										</select>
									</div>
                                </div>
								<div class="row">
									<div class="input-field col s7">
										<p><b>Informe a carga horária por turma de:</b></p>
									</div>
								</div>
								<div class='row'>
									<div class="input-field col s12 m12 l4 xl4">
										<input title="Horas de planejamento (valor entre 1 e 999)" type="number" id="horas_planejamento" name="horas_planejamento" v-model='inscricao.turma.horas_planejamento' min="1" max="999" :disabled="retornaSeFormularioDesabilitadoParaEdicao">
										</input>
										<label for="horas_planejamento">Planejamento</label>
									</div>
									<div class="input-field col s12 m12 l4 xl4">
										<input title="Horas de execução (valor entre 1 e 999)" type="number" id="horas_execucao" name="horas_execucao" v-model='inscricao.turma.horas_execucao' min="1" max="999" :disabled="retornaSeFormularioDesabilitadoParaEdicao">
										</input>
										<label for="horas_execucao">Execução</label>
									</div>
									<div class="input-field col s12 m12 l4 xl4">
										<input title="Horas de avaliação (valor entre 1 e 999)" type="number" id="horas_avaliacao" name="horas_avaliacao" v-model='inscricao.turma.horas_avaliacao' min="1" max="999" :disabled="retornaSeFormularioDesabilitadoParaEdicao">
										</input>
										<label for="horas_avaliacao">Avaliação</label>
									</div>
								</div>
								<Resultado_analise_turmas_curso
												 v-if="analiseTecnica"
												 :inscricao="inscricao"></Resultado_analise_turmas_curso>
                            </div>
                        </div>
                    </div>

                    <!-- PARCERIAS -->
                    <div class="row" v-if="modoTela !== 'correcao' || retornaSeItemEncontraSeEmPendenciaNaAnaliseTecnica('item_acao_possui_parcerias_externas_validacao')">
                        <div class="col s12">
                            <div class="card-panel" :style="retornaBordaVermelhaNoItemEmPendenciaNaAnaliseTecnica('item_acao_possui_parcerias_externas_validacao')">
                                <div class="row">
                                    <div class="col s12 red darken-1 white-text" v-if="retornaSeItemEncontraSeEmPendenciaNaAnaliseTecnica('item_acao_possui_parcerias_externas_validacao')">
                                        <p>
                                            <i class="material-icons left">info_outline</i>
                                            <span style="font-weight: bold;">Aviso!</span>
                                            <span> Este item encontra-se pendênciado na análise técnica, por favor realize a correção. </span>
                                        </p>
                                    </div>

                                    <h5 class="col s12">Parcerias</h5>

                                    <p v-if="!acaoSelecionada" class="label-info-nao-encontrada">Nenhuma ação foi selecionada ainda!</p>

                                    <Parcerias v-else
                                               :p-quantidade-parcerias.sync = "inscricao.quantidade_parcerias"
                                               :all-disabled="retornaSeFormularioDesabilitadoParaEdicao"
                                               :p-acao-possui-parcerias-externas.sync="inscricao.acao_possui_parcerias_externas"
                                               :p-anexos.sync="inscricao.anexos"
                                               :p-analise-tecnica="analiseTecnica"></Parcerias>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ATUAÇÕES EM TERRITÓRIOS E/OU JUNTO AOS GRUPOS VULNERÁVEIS -->
                    <div class="row" v-if="modoTela !== 'correcao'">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Atuação em territórios e/ou junto aos grupos vulneráveis</h5>

                                    <p v-if="!acaoSelecionada" class="label-info-nao-encontrada">Nenhuma ação foi selecionada ainda!</p>

                                    <Inscricao_atuacoes v-else
                                                        :all-disabled="retornaSeFormularioDesabilitadoParaEdicao"
                                                        :p-acao-atgv.sync="inscricao.acao_atgv"
                                                        :p-atuacoes-configuradas="atuacoes"
                                                        :p-atuacoes-selecionadas.sync="inscricao.lista_de_atuacoes"
                                                        :p-avaliacoes="avaliacoes"></Inscricao_atuacoes>
                                </div>
                            </div>
                        </div>
                    </div>
					
					<!-- AÇÕES AFIRMATIVAS -->
                    <div class="row" v-if="modoTela !== 'correcao'">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Políticas de Ação Afirmativa</h5>

                                    <p v-if="!acaoSelecionada" class="label-info-nao-encontrada">Nenhuma ação foi selecionada ainda!</p>

                                    <Inscricao_acoes_afirmativas v-else
                                                        :all-disabled="retornaSeFormularioDesabilitadoParaEdicao"
                                                        :p-acao-afirmativa.sync="inscricao.acao_afirmativa"
                                                        :p-desc-acao-afirmativa.sync="inscricao.desc_acao_afirmativa"
                                                        :p-avaliacoes="avaliacoes"></Inscricao_acoes_afirmativas>
                                </div>
                            </div>
                        </div>
                    </div>
					
					<!-- POLÍTICAS PÚBLICAS DE PROGRAMA E PROJETO -->
                    <div v-if="acaoSelecionada && (acaoSelecionada.modalidade == 'Programa' || acaoSelecionada.modalidade == 'Projeto') && modoTela !== 'correcao'" class="row">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Políticas Públicas</h5>

                                    <Inscricao_acao_politicas_publicas 
                                                        :all-disabled="retornaSeFormularioDesabilitadoParaEdicao"
                                                        :p-acao-politicas-publicas.sync="inscricao.acao_politicas_publicas"
                                                        :p-desc-acao-politicas-publicas.sync="inscricao.desc_acao_politicas_publicas"
                                                        :p-avaliacoes="avaliacoes"></Inscricao_acao_politicas_publicas>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- COTAS & MESES -->
                    <div class="row" v-if="modoTela !== 'correcao'">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Bolsas de Extensão</h5>

                                    <p v-if="!acaoSelecionada" class="label-info-nao-encontrada">Nenhuma ação foi selecionada ainda!</p>

                                    <section v-else class="col s12">

                                        <div class="row">
                                            <!--div class="col s12 blue-grey lighten-5" v-if="configuracaoDaModalidadeDaAcaoSelecionada">
                                                <p>
                                                    <i class="material-icons blue-text text-darken-3 left">info</i>
                                                    <span style="font-weight: bold;">Informação!</span>
                                                    <span>De acordo com a modalidade da sua ação <b>({{ configuracaoDaModalidadeDaAcaoSelecionada ? configuracaoDaModalidadeDaAcaoSelecionada.descricao : 'N/a' }})</b> você
                                                    só poderá requisitar a utilização de até </span>&nbsp;<b><span>{{ configuracaoDaModalidadeDaAcaoSelecionada.numero_cotas }} Bolsa(s)</span></b> por até
                                                    <b><span>{{ configuracaoDaModalidadeDaAcaoSelecionada.numero_meses }} Mes(es).</span></b>
                                                </p>
                                            </div-->

                                            <div class="col s12 blue-grey lighten-5" v-if="configuracaoDaModalidadeDaAcaoSelecionada">
                                                <p>
                                                    <i class="material-icons yellow-text text-darken-3 left">warning</i>
                                                    <span style="font-weight: bold;">Aviso!</span>
                                                    <span> Sempre que a quantidade de bolsas for alterada, os planos de trabalho serão removidos e será necessário preenchê-los novamente! </span>
                                                </p>
                                            </div>
                                        </div>


                                        <div v-for="(bolsa, bolsa_i) in inscricao.bolsas_extensao" class="row" :key="bolsa_i">
                                            <div class="col m6 s12">
                                                <input type="text" :name="`nome_bolsa_${bolsa_i}`" :id="`nome_bolsa_${bolsa_i}`"
                                                       disabled
                                                       :value="`Bolsa de Extensão ${bolsa.codigo}`" />
                                                <label :for="`nome_bolsa_${bolsa_i}`">Bolsa</label>
                                            </div>

                                            <div class="col m6 s12">
                                                <input type="number"
                                                       min="0"
                                                       :max="bolsa.limite_bolsas"
                                                       :name="`qtd_bolsa_${bolsa_i}`" :id="`qtd_bolsa_${bolsa_i}`"
                                                       class="numeric-disabled-text"
                                                       onkeydown="return false"
                                                       step="1"
                                                       v-model="bolsa.quantidade_bolsas_selecionadas" />

                                                <label :for="`qtd_bolsa_${bolsa_i}`">Quantidade</label>
                                            </div>
                                        </div>


                                        <div class="row">
                                            <div class="input-field col s12">
                                                <label style="font-size:16px;font-weight:bold" class='active' for="quantidade_meses">Por quantos meses você deseja solicitar essas bolsas?</label><br>
                                                <select name="quantidade_meses"
                                                        id="quantidade_meses"
                                                        tipo="materialize"
                                                        :disabled="retornaSeFormularioDesabilitadoParaEdicao"
                                                        v-model.number="inscricao.quantidade_meses"
                                                        class="validate browser-default">
                                                    <option value="" disabled selected>Número de meses</option>
                                                    <option v-for="meses in (configuracaoDaModalidadeDaAcaoSelecionada ? configuracaoDaModalidadeDaAcaoSelecionada.numero_meses : 1)" :value=meses>{{meses}}</option>
                                                </select>
                                            </div>
                                        </div>


                                    </section>

                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- PLANOS DE TRABALHO -->
                    <div class="row" v-if="modoTela !== 'correcao'">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Planos de Trabalho</h5>

                                    <p v-if="!acaoSelecionada" class="label-info-nao-encontrada">Nenhuma ação foi selecionada ainda!</p>

                                    <p v-else-if="retornaQuantidadeDeBolsasDeExtensao === 0 && !inscricao.planos_de_trabalho.length"
                                       class="label-info-nao-encontrada">Só é realizado o preenchimento de planos de trabalho quando a quantidade de bolsas é maior que zero 0!</p>

                                    <section v-else>
                                        <Planos_de_trabalho :all-disabled="retornaSeFormularioDesabilitadoParaEdicao"
                                                            :p-quantidade-cotas="retornaQuantidadeDeBolsasDeExtensao"
                                                            :p-planos-de-trabalho="inscricao.planos_de_trabalho"
                                                            :itens-do-plano-de-trabalho="configuracaoDaInscricao.plano_trabalho"
                                                            :p-avaliacoes="avaliacoes"
                                                            :repetiu-pdt-bolsista="inscricao.repetiu_pdt_bolsista"
															:modalidade="acaoSelecionada.modalidade"></Planos_de_trabalho>

                                        <!-- REPETIU O MESMO PLANO DE TRABALHO PARA MAIS DE UM BOLSISTA? (JUSTIFICATIVA) -->
                                        <div class="row">
                                            <div class="col s12">
                                                <Pdt_repetiu_justificativa
                                                    :all-disabled="retornaSeFormularioDesabilitadoParaEdicao"
                                                    :p-repetiu-pdt-bolsista.sync="inscricao.repetiu_pdt_bolsista"
                                                    :p-repetiu-pdt-bolsista-justificativa.sync="inscricao.repetiu_pdt_bolsista_justificativa"
                                                    :maximo-de-caracteres-para-justificativa-pdt-repetido="configuracaoDaInscricao.justificativa_pdt_repetido"></Pdt_repetiu_justificativa>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>


                    </div>

                    <!-- PARTICIPAÇÕES NA SIAC -->
                    <div class="row" v-if="modoTela !== 'correcao' || retornaSeItemEncontraSeEmPendenciaNaAnaliseTecnica('item_apresentacao_de_trabalho_na_siac')">
                        <div class="col s12">
                            <div class="card-panel" :style="retornaBordaVermelhaNoItemEmPendenciaNaAnaliseTecnica('item_apresentacao_de_trabalho_na_siac')">
                                <div class="row">
                                    <div class="col s12 red darken-1 white-text" v-if="retornaSeItemEncontraSeEmPendenciaNaAnaliseTecnica('item_apresentacao_de_trabalho_na_siac')">
                                        <p>
                                            <i class="material-icons left">info_outline</i>
                                            <span style="font-weight: bold;">Aviso!</span>
                                            <span> Este item encontra-se pendênciado na análise técnica, por favor realize a correção. </span>
                                        </p>
                                    </div>

                                    <h5 class="col s12">Participações na SIAC</h5>

                                    <p class="label-carregamento" v-if="buscandoParticipacoesNaSiac"><span>Buscando as participações na API da SIAC...</span></p>

                                    <Participacoes_na_siac v-else
                                                           :participacoes-na-siac="participacoesNaSiac"
                                                           :p-analise-tecnica="analiseTecnica"></Participacoes_na_siac>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- LISTAGEM DE BOLSISTAS DA AÇÃO NO EDITAL ANTERIOR -->
                    <div class="row" v-if="modoTela !== 'correcao' || retornaSeItemEncontraSeEmPendenciaNaAnaliseTecnica('item_relatorio_de_bolsistas')">
                        <div class="col s12">
                            <div class="card-panel" :style="retornaBordaVermelhaNoItemEmPendenciaNaAnaliseTecnica('item_relatorio_de_bolsistas')">
                                <div class="row">
                                    <div class="col s12 red darken-1 white-text" v-if="retornaSeItemEncontraSeEmPendenciaNaAnaliseTecnica('item_relatorio_de_bolsistas')">
                                        <p>
                                            <i class="material-icons left">info_outline</i>
                                            <span style="font-weight: bold;">Aviso!</span>
                                            <span> Este item encontra-se pendênciado na análise técnica, por favor realize a correção. </span>
                                        </p>
                                    </div>

                                    <h5 class="col s12">Bolsistas da Ação no Edital Anterior</h5>

                                    <Relatorio_bolsistas_edital_anterior :p-analise-tecnica="analiseTecnica"
                                                                         :p-trabalhos-apresentados-na-siac="trabalhosApresentadosNaSiac"
                                                                         :siga-acao-oid="retornaSigaAcaoOid"
                                                                         :csrf-token="csrfToken"
                                                                         :all-disabled="retornaSeFormularioDesabilitadoParaEdicao"></Relatorio_bolsistas_edital_anterior>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- DEMAIS ITENS DO RESULTADO DA ANÁLISE TÉCNICA -->
                    <div class="row" v-if="modoTela !== 'correcao' && analiseTecnica">
                        <div class="col s12">
                            <div class="card-panel" style="border: 1px solid #2196F3;">
                                <div class="row">
                                    <h5 class="col s12">Demais itens da análise técnica</h5>

                                    <Demais_itens_analise_tecnica :analise-tecnica="analiseTecnica"></Demais_itens_analise_tecnica>
                                </div>
                            </div>
                        </div>


                    </div>

                    <!-- ESPECIFICAÇÃO DAS CORREÇÕES NECESSÁRIAS NA PROPOSTA (EM CASO DE EXIGÊNCIA NA ANÁLISE TÉCNICA)  -->
                    <div class="row" v-if="modoTela === 'correcao'">
                        <div class="col s12">
                            <div class="card-panel" style="border: 1px solid #2196F3;">
                                <div class="row">
                                    <h5 class="col s12">Parecer do Analista Técnico</h5>

                                    <Especificacao_correcoes_proposta :p-parecer-exigencia="especificacaoDasCorrecoesProposta"></Especificacao_correcoes_proposta>
                                </div>
                            </div>
                        </div>


                    </div>

                    <!-- OBSERVAÇÃO/PARECER DO ANALISTA TÉCNICO -->
                    <div class="row" v-if="modoTela === 'visualizaAvaliacoes' && analiseTecnica != null">

                        <div class="col s12">
                            <div class="card-panel" style="border: 2px solid #8c9eff">
                                <div class="row">
                                    <h5 class="col s12">Parecer do Analista Técnico</h5>

                                    <Observacoes_analista_tecnico :p-observacoes-analista-tecnico="analiseTecnica.parecer_eliminado"></Observacoes_analista_tecnico>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- PARECERES DAS AVALIAÇÕES -->
                    <div class="row" v-if="modoTela === 'visualizaAvaliacoes' && avaliacoes != null && avaliacoes.length > 0">
                        <div class="col s12">
                            <div class="card-panel" style="border: 2px solid #00b8d4">
                                <div class="row">
                                    <h5 class="col s12">Pareceres dos Avaliadores</h5>

                                    <Pareceres_dos_avaliadores :p-avaliacoes="avaliacoes"></Pareceres_dos_avaliadores>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="modoTela === 'visualizaAvaliacoes' || modoTela === 'correcao'">
                        <Quadro_legendas></Quadro_legendas>
                    </div>
                </form>
            </div>
        </div>
        <div class="row" v-if='inscricao.parcial !== false'>
            <div class="col s12">
                <a class="btn-large waves-effect waves-light indigo"
                   v-if="podeSalvarDadosNoFormulario"
                   @click="salvarParcial"><i class="material-icons left">save</i>Salvar parcial</a>
            </div>
        </div>
        <div class="row">
            <div class="col s12">
                <a class="btn-large waves-effect waves-light indigo"
                   v-if="podeSalvarDadosNoFormulario"
                   @click="salvarDados"><i class="material-icons left">save</i>Enviar</a>
            </div>
        </div>
    </section>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Inscricao_questionario_itens from "./inscricao_questionario_itens";
import Cronograma_atividades from "./cronograma_atividades";
import Parcerias from "./parcerias";
import Inscricao_atuacoes from "./inscricao_atuacoes";
import Inscricao_acoes_afirmativas from "./inscricao_acoes_afirmativas";
import Inscricao_acao_politicas_publicas from "./inscricao_acao_politicas_publicas";
import Planos_de_trabalho from "./planos_de_trabalho";
import Pdt_repetiu_justificativa from "./pdt_repetiu_justificativa";
import Participacoes_na_siac from "./participacoes_na_siac";
import Especificacao_correcoes_proposta from "./analise_tecnica_resultado/especificacao_correcoes_proposta";
import Observacoes_analista_tecnico from "./analise_tecnica_resultado/observacoes_analista_tecnico";
import Pareceres_dos_avaliadores from "./avaliacoes_resultado/pareceres_dos_avaliadores";
import Relatorio_bolsistas_edital_anterior from "./relatorio_bolsistas_edital_anterior";
import Quadro_legendas from "./quadro_legendas";
import Demais_itens_analise_tecnica from "./analise_tecnica_resultado/demais_itens_analise_tecnica";
import Resultado_avaliacoes_qtdo_evento from "./avaliacoes_resultado/resultado_avaliacoes_qtdo_evento";
import Resultado_analise_turmas_curso from "./analise_tecnica_resultado/resultado_analise_turmas_curso";

export default {
    name: "create_or_update",
    provide: function () {
        return {
            principal: this
        }
    },
    components: {
        Demais_itens_analise_tecnica,
        Quadro_legendas,
        Relatorio_bolsistas_edital_anterior,
        Pareceres_dos_avaliadores,
        Observacoes_analista_tecnico,
        Especificacao_correcoes_proposta,
        Participacoes_na_siac,
        Pdt_repetiu_justificativa,
        Planos_de_trabalho,
        Inscricao_atuacoes,
		Inscricao_acoes_afirmativas,
		Inscricao_acao_politicas_publicas,
        Parcerias,
        Cronograma_atividades,
        Inscricao_questionario_itens,
		Resultado_avaliacoes_qtdo_evento,
		Resultado_analise_turmas_curso,
        Loading,
    },
    props: {
        modoTela: {
            type: String,
            default: null,
            required: true,
        },

        csrfToken: {
            type: String,
            default: null,
            required: true,
        },

        routeSaveData: {
            type: String,
            default: null,
            required: true,
        },

        routeList: {
            type: String,
            default: null,
            required: true,
        },

        pParticipacoesNaSiac: {
            type: String,
            default: null,
            required: true,
        },

        pEdital: {
            type: String,
            default: null,
            required: true
        },

        pAcoesParaInscricao: {
            type: String,
            default: null,
            required: false
        },

        pAtuacoes: {
            type: String,
            default: null,
            required: true
        },

        pInscricao: {
            type: String,
            default: null,
            required: true
        },

        pUsuarioLogado: {
            type: String,
            default: null,
            required: true
        },

        pConfiguracaoDaInscricao: {
            type: String,
            default: null,
            required: true
        },

        pAnaliseTecnica: {
            type: String,
            default: null,
            required: true
        },

        pAvaliacoes: {
            type: String,
            default: null,
            required: true
        },
		pFaixas: {
            type: String,
            default: null,
            required: true
        },
		pEventoQtdos: { 
			type: String,
            default: null,
            required: true
		},
		msgCronogramaAtividades: {
            type: String,
            default: null,
            required: true
        }
    },
    data() {
        return {
            participacoesNaSiac: JSON.parse(this.pParticipacoesNaSiac),
            trabalhosApresentadosNaSiac: null,
            edital: JSON.parse(this.pEdital),
            acoesParaInscricao: this.pAcoesParaInscricao != null && this.pAcoesParaInscricao !== '' ? JSON.parse(this.pAcoesParaInscricao) : null,
            atuacoes: JSON.parse(this.pAtuacoes),
            inscricao: JSON.parse(this.pInscricao),
            usuarioLogado: JSON.parse(this.pUsuarioLogado),
            configuracaoDaInscricao: JSON.parse(this.pConfiguracaoDaInscricao),
            analiseTecnica: this.pAnaliseTecnica != null && this.pAnaliseTecnica !== '' ? JSON.parse(this.pAnaliseTecnica) : null,
            avaliacoes: this.pAvaliacoes != null && this.pAvaliacoes !== '' ? JSON.parse(this.pAvaliacoes) : null,
            faixas: this.pFaixas != null? JSON.parse(this.pFaixas) : null,
			eventoQtdos: JSON.parse(this.pEventoQtdos),
			loading: false,
            buscandoParticipacoesNaSiac: false,
            buscandoTrabalhosNaSiac: false,
        }
    },
    watch: {
        acaoSelecionada(newValue) {
            this.insereBolsasDeExtensaoDaModalidadeDaAcaoSelecionada()
        }
    },
    computed: {
        acaoSelecionada() {
			var acao,
				combo = document.getElementById('sel_escolha_acao');
			
            if(this.modoTela === 'cadastro'){
                if(!this.inscricao.acaos_id)
                    return null;

                acao = _.find(this.acoesParaInscricao, (acao) => { return acao.id === this.inscricao.acaos_id; });
				this.inscricao.planos_de_trabalho = [];
			
				if (acao.modalidade == 'Curso')
					this.inscricao.turma = {qtde_turmas: 0, horas_planejamento: 0, horas_execucao: 0, horas_avaliacao: 0};
			} else
                acao = this.inscricao.acao;
			
			if (combo && this.estorouLimiteFaixa(acao.modalidade)) {
				
				Swal.fire('Ação inválida!', 'Você já realizou o máximo de inscrições na faixa dessa modalidade!', 'error')
				combo.value = this.inscricao.acaos_id = '';
				combo.selectedIndex = -1;
				return null;
			}    
			return acao;
        },
        configuracaoDaModalidadeDaAcaoSelecionada() {
            if(!this.acaoSelecionada)
                return null;

            const modalidadeAcaoSelecionada = _.lowerCase(this.acaoSelecionada.modalidade)

            return _.find(this.configuracaoDaInscricao.modalidades, (modalidade) => { return modalidadeAcaoSelecionada === _.lowerCase(modalidade.descricao); })
        },
        especificacaoDasCorrecoesProposta(){
            if(this.modoTela !== 'correcao')
                return null;
            else if(!this.inscricao.hasOwnProperty('resultado_analise_tecnica') || this.inscricao.resultado_analise_tecnica === null || !this.inscricao.resultado_analise_tecnica.especificacao_correcoes_proposta)
                return null;
            else
                return this.inscricao.resultado_analise_tecnica.especificacao_correcoes_proposta;

        },
        retornaSeFormularioDesabilitadoParaEdicao(){
            return this.modoTela === 'visualizacao' || this.modoTela === 'visualizaAvaliacoes'
        },

        podeSalvarDadosNoFormulario(){
            return this.inscricao.acaos_id && (this.modoTela === 'cadastro' || this.modoTela === 'edicao' || this.modoTela === 'correcao')
        },

        retornaSigaAcaoOid(){
            const acao = this.acaoSelecionada

            return !acao ? null : acao.siga_acao_oid;
        },

        retornaQuantidadeDeBolsasDeExtensao(){
            if(!this.inscricao || !this.inscricao.bolsas_extensao || this.inscricao.bolsas_extensao.length === 0)
                return 0
            else{
                let totalBolsas = this.inscricao.bolsas_extensao.reduce((total, bolsa) => {
                    let { quantidade_bolsas_selecionadas } = bolsa
                    return parseInt(total) + parseInt(quantidade_bolsas_selecionadas)
                }, 0)

                return parseInt(totalBolsas)
            }
        }
    },
    methods: {

        insereBolsasDeExtensaoDaModalidadeDaAcaoSelecionada(){
            if(!this.acaoSelecionada)
                return false

            if(this.inscricao.bolsas_extensao)
                this.inscricao.bolsas_extensao.splice(0)

            if(!this.configuracaoDaModalidadeDaAcaoSelecionada.bolsas_extensao){
                Swal.fire('Ação inválida!', 'As bolsas de extensão não foram configuradas para a modalidade selecionada, favor informar isso ao suporte do Profaex.', 'error')
                return false
            }

            this.inscricao.bolsas_extensao = []
            _.forEach(this.configuracaoDaModalidadeDaAcaoSelecionada.bolsas_extensao, (bolsa) => {
                this.inscricao.bolsas_extensao.push({
                    codigo: bolsa.codigo,
                    limite_bolsas: bolsa.quantidade_bolsas,
                    quantidade_bolsas_selecionadas: 0,
                })
            })
        },

        inicializaInscricao() {
            if(!this.inscricao.hasOwnProperty('id'))
                this.$set(this.inscricao, 'id', null)

            if(!this.inscricao.hasOwnProperty('cronograma_de_atividades'))
                this.$set(this.inscricao, 'cronograma_de_atividades', [])

            if (!this.inscricao.hasOwnProperty('planos_de_trabalho'))
                this.$set(this.inscricao, 'planos_de_trabalho', [])

            if (!this.inscricao.hasOwnProperty('lista_de_atuacoes'))
                this.$set(this.inscricao, 'lista_de_atuacoes', [])

            if (!this.inscricao.hasOwnProperty('anexos'))
                this.$set(this.inscricao, 'anexos', [])

        },
        async salvarParcial() {

            const payload = this.serializaInscricaoParaFormData()

            this.loading = true

            const url = this.inscricao.id === null ? '/api/inscricaos/parcial' : '/api/inscricaos/update/parcial/' + this.inscricao.id

            await this.$http.post(url, payload, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                // window.location.href = `${this.routeList}/?msg=${response.body.msg}`
                Swal.fire('Sucesso!', response.body.msg, 'success')
                this.inscricao.id = response.body.id
            }, error => {
                const exceptionMensagem = _.replace(_.replace(error.body.exception, '#nr1', '<b>'), '#nr2', '</b>')

                Swal.fire({title: 'Ocorreu um erro!', html: exceptionMensagem, footer: error.body.msg, icon: 'error'})
            })

            this.loading = false

        },

        async salvarDados() {
            let confirmaEnvio = true;

            if (this.modoTela === 'correcao') {
                await Swal.fire({
                    title: 'Tem certeza que deseja enviar a proposta?',
                    text: "Após enviar a proposta novamente a mesma não poderá mais ser editada e essa ação não poderá ser desfeita!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!',
                    cancelButtonText: 'Cancelar.'
                }).then((result) => {
                    confirmaEnvio = result.isConfirmed
                })
            }

            if(confirmaEnvio){
                const payload = this.serializaInscricaoParaFormData()

                this.loading = true

                const url = this.inscricao.id === null ? '/api/inscricaos' : '/api/inscricaos/update/' + this.inscricao.id

                await this.$http.post(url, payload, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    window.location.href = `${this.routeList}/?msg=${response.body.msg}`
                    //Swal.fire('Sucesso!', response.body.msg, 'success')
                }, error => {
                    const exceptionMensagem = _.replace(_.replace(error.body.exception, '#nr1', '<b>'), '#nr2', '</b>')

                    Swal.fire({ title: 'Ocorreu um erro!', html: exceptionMensagem, footer: error.body.msg, icon: 'error'})
                })

                this.loading = false
            }
        },

        serializaInscricaoParaFormData(){
            let formInscricao = new FormData()

            if(this.modoTela === 'correcao')
                this.$set(this.inscricao, 'reenvio', true)

            formInscricao.append('_token', this.csrfToken)

            formInscricao.append('editalId', this.edital.id)

            formInscricao.append('inscricao', JSON.stringify(this.inscricao))

            const itensComAnexo = _.filter(this.inscricao.itens, (item) => { return item.hasOwnProperty('anexo') })

            _.forEach(itensComAnexo, (item, indice) => {
                if(item.anexo.hasOwnProperty('arquivo')) {
                    formInscricao.append('itens_anexo_info[' + indice + ']', JSON.stringify(item.anexo))
                    formInscricao.append('itens_anexo_arquivo[' + indice + ']', item.anexo.arquivo, item.anexo.nome_anexo)
                }
            })

            _.forEach(this.inscricao.planos_de_trabalho, (plano, indice_plano) => {
                _.forEach(plano.itens, (item, indice_item) => {
                    formInscricao.append(`pdt_itens_info[${indice_plano}][${indice_item}]`, JSON.stringify(item))

                    if(item.hasOwnProperty('anexo'))
                        formInscricao.append(`pdt_itens_arquivo[${indice_plano}][${indice_item}]`, item.anexo.arquivo, item.anexo.nome_anexo)
                })
            })

            if(this.inscricao.acao_possui_parcerias_externas && this.inscricao.anexos && this.inscricao.anexos.length > 0){
                _.forEach(this.inscricao.anexos, (anexo, indice) => {
                    if(anexo.hasOwnProperty('arquivo')) {
                        formInscricao.append('parcerias_anexo_info[' + indice + ']', JSON.stringify(anexo))
                        formInscricao.append('parcerias_anexo_arquivo[' + indice + ']', anexo.arquivo, anexo.nome_anexo)
                    }
                })
            }

            return formInscricao

        },

        retornaSeItemEncontraSeEmPendenciaNaAnaliseTecnica(item){
            if(!this.inscricao.hasOwnProperty('resultado_analise_tecnica') || this.modoTela !== 'correcao')
                return false;

            return _.findIndex(this.inscricao.resultado_analise_tecnica.itens_em_exigencia, (item_exigencia) => {
                return item_exigencia === item;
            }) > -1
        },

        retornaBordaVermelhaNoItemEmPendenciaNaAnaliseTecnica(item){
            if(this.retornaSeItemEncontraSeEmPendenciaNaAnaliseTecnica(item))
                return "border: 1px solid red;"

            return null;
        },

        async obtemAtuacoesNaSiac(){
            try {
                let cpf = null;

                if(this.modoTela === 'cadastro')
                    cpf = this.usuarioLogado.cpf
                else
                    cpf = this.inscricao.usuario.cpf;

                this.buscandoParticipacoesNaSiac = true;

                let {data} = await this.$http.get(`/api/siac-provider/obtem-atuacao-na-siac/${cpf}/${this.edital.siac_anterior}`);

                if(data){
                    this.participacoesNaSiac = data;
                }

                this.buscandoParticipacoesNaSiac = false;

            } catch (error) {
                console.error(error);
            }
        },

        async obtemTrabalhosApresentadosNaSiacPeloUsuarioNoEditalAnterior(){
            try {
                let cpf = null;

                if(this.modoTela === 'cadastro')
                    cpf = this.usuarioLogado.cpf
                else
                    cpf = this.inscricao.usuario.cpf;

                this.buscandoTrabalhosNaSiac = true;

                let {data} = await this.$http.get(`/api/siac-provider/obtem-trabalhos-na-siac/${cpf}/${this.edital.siac_anterior}`);

                if(data){
                    this.trabalhosApresentadosNaSiac = data;
                }

                this.buscandoTrabalhosNaSiac = false;

            } catch (error) {
                console.error(error);
            }
        },
		estorouLimiteFaixa(modalidade) {
			var faixas = this.faixas,
				i = faixas.length;
				
			while (--i >= 0)
				if (faixas[i].modalidades.includes(modalidade)) {
					if (faixas[i].max_inscricoes)
						return false;
					return true;
				}	
		},
		aumentarInscFaixa() {
			var modalidade = this.inscricao.acao.modalidade,
				faixas = this.faixas,
				i = faixas.length;
				
			while (--i >= 0)
				if (faixas[i].modalidades.includes(modalidade)) {
					faixas[i].max_inscricoes++;
					return;
				}
		}
    },
    mounted() {
		
		if (this.modoTela != 'cadastro')
			this.aumentarInscFaixa();

        M.updateTextFields()

        this.inicializaInscricao()

        this.obtemAtuacoesNaSiac()

        this.obtemTrabalhosApresentadosNaSiacPeloUsuarioNoEditalAnterior()
	},
    updated() {
        M.updateTextFields()
    }
}
</script>

<style scoped>

</style>
